import { apiClient } from "./apiClient";

export interface OrganizationSettings {
  check_reminder_hours: number;
  check_reminder_minutes: number;
  send_missed_checks_to_admins: boolean;
  send_text_reminders: boolean;
  max_systems_per_user: number;
}

export const getOrganizationSettings = async (): Promise<OrganizationSettings> => {
  const response = await apiClient.get('/api/v1/organization-settings');
  if (!response?.ok) {
    throw new Error('Failed to fetch organization settings');
  }
  return response.json();
};

export const updateOrganizationSettings = async (settings: OrganizationSettings): Promise<OrganizationSettings> => {
  const response = await apiClient.request('/api/v1/organization-settings', {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(settings)
  });
  if (!response?.ok) {
    throw new Error('Failed to update organization settings');
  }
  return response.json();
};